import { FilterSelect } from '../../../commonComponents/filters/FilterSelect';

export const CustomFilters = ({ filter, handleFilterChange, FILTERS }) => (
  <>
    {FILTERS.map(({ key, label, options }) => (
      <FilterSelect
        key={key}
        id={key}
        label={label}
        options={options}
        value={filter[key]}
        onChange={handleFilterChange}
      />
    ))}
  </>
);
